import * as io from "io-ts";

export const RecipientResolver = io.intersection([
  io.type({
    recipientId: io.number,
    address: io.string, // Email
    status: io.string,
    dateJoined: io.string, // Date
  }),
  io.partial({
    externalId: io.union([io.string, io.null]), // Email
    channel: io.string,
    comment: io.union([io.string, io.null]),
    sourceDescription: io.string,
    sourceSignupDate: io.union([io.string, io.null]), // Date
    signupIP: io.union([io.string, io.null]),
    signupMethod: io.union([io.string, io.null]),
    dateUnsub: io.union([io.string, io.null]), // Date
    demographics: io.array(io.string),
  }),
]);

export const AnonymousRecipientResolver = io.intersection([
  io.type({
    address: io.string, // Email
  }),
  io.partial({
    recipientId: io.number,
    status: io.string,
    dateJoined: io.string, // Date
    externalId: io.union([io.string, io.null]), // Email
    channel: io.string,
    comment: io.union([io.string, io.null]),
    sourceDescription: io.string,
    sourceSignupDate: io.union([io.string, io.null]), // Date
    signupIP: io.union([io.string, io.null]),
    signupMethod: io.union([io.string, io.null]),
    dateUnsub: io.union([io.string, io.null]), // Date
    demographics: io.array(io.string),
  }),
]);

export const RecipientListResolver = io.array(RecipientResolver);
export type Recipient = io.TypeOf<typeof RecipientResolver>;
export type AnonymousRecipient = io.TypeOf<typeof AnonymousRecipientResolver>;

export const StationResolver = io.intersection([
  io.type({
    listId: io.number,
    title: io.string,
    populated: io.boolean,
    publicSignup: io.boolean,
    channel: io.string,
  }),
  io.partial({
    friendlyTitle: io.string,
    description: io.string,
    externalId: io.union([io.string, io.null]),
  }),
]);
export const StationListResolver = io.array(StationResolver);
export type Station = io.TypeOf<typeof StationResolver>;

export const PostUpResolver = io.intersection([
  io.type({
    listId: io.number,
    recipientId: io.number,
    status: io.string,
  }),
  io.partial({
    dateJoined: io.string, // Date
    address: io.string, // Email
    mailingId: io.union([io.string, io.null]),
    confirmed: io.boolean,
    sourceId: io.union([io.string, io.null]),
    dateUnsub: io.union([io.string, io.null]), // Date
    listStatus: io.string,
    globalStatus: io.string,
  }),
]);
export const PostUpListResolver = io.array(PostUpResolver);
export type PostUp = io.TypeOf<typeof PostUpResolver>;
export type PostUpList = io.TypeOf<typeof PostUpListResolver>;

export const MailResponseResolver = io.partial({
  mailingId: io.number,
  title: io.string,
  brandId: io.number,
  campaignId: io.number,
  categoryId: io.number,
  creator: io.string,
  channel: io.string,
  listIds: io.null,
  segmentIds: io.null,
  content: io.null,
  abMailing: io.null,
  clickTrackType: io.string,
  openTrackType: io.string,
  seeds: io.array(io.undefined),
  seedListId: io.null,
  purgeListIds: io.array(io.undefined),
  suppressionListIds: io.array(io.undefined),
  blockDomains: io.array(io.undefined),
  scheduledTime: io.string,
  externalId: io.string,
  maxRecips: io.number,
  status: io.string,
  realtime: io.boolean,
});
export type MailResponse = io.TypeOf<typeof MailResponseResolver>;

export enum PostUpStatus {
  normal = "NORMAL",
  unsub = "UNSUB",
}
export interface PostUpListRequest {
  recipientId: number;
  listId: number;
  status: PostUpStatus;
}

export interface ErrorData {
  message: string;
}

export interface ErrorResponse {
  data: ErrorData;
  status: string;
}
